import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BarChartComponent } from "./bar-chart.component";
import { TranslateModule } from "@ngx-translate/core";
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule,
    ],
  declarations: [
    BarChartComponent
  ],
  exports: [
    BarChartComponent
  ]
})
export class BarChartModule {}
